














import { Component, Vue } from "vue-property-decorator";
import PoweredByDarkSky from "@/components/PoweredByDarkSky.vue";

const dependencies = [
  "@types/color",
  "@types/faker",
  "@types/jest",
  "@types/js-cookie",
  "@types/lodash",
  "@types/uuid",
  "@vue/cli-plugin-e2e-cypress",
  "@vue/cli-plugin-eslint",
  "@vue/cli-plugin-typescript",
  "@vue/cli-plugin-unit-jest",
  "@vue/cli-service",
  "@vue/eslint-config-prettier",
  "@vue/eslint-config-typescript",
  "@vue/test-utils",
  "axios",
  "babel-eslint",
  "bootstrap-vue",
  "bootstrap",
  "color",
  "date-fns",
  "eslint-plugin-vue",
  "eslint",
  "faker",
  "js-cookie",
  "lint-staged",
  "lodash",
  "sass-loader",
  "sass",
  "scrollmagic",
  "ts-jest",
  "typescript",
  "uuid",
  "vue-class-component",
  "vue-infinite-loading",
  "vue-property-decorator",
  "vue-router",
  "vue-template-compiler",
  "vue",
  "vuedraggable",
  "vuex-persistedstate",
  "vuex"
];

@Component({
  components: {
    PoweredByDarkSky
  }
})
export default class License extends Vue {
  get dependencies(): string[] {
    return dependencies;
  }
}
